import Vue from 'vue';

export default {
    setQuery(state, query) {
        state.query = Object.assign({}, state.query, query);
        console.log('STORE - Set query obj');
    },

    resetQuery(state) {
        Object.assign(state.query, state.defaultQuery)
        console.log("Reset query object to default")
        console.log(state.query)
    },

    setBaseQuery(state) {
        // This is a bit of a different reset.
        // The goal is to set the query to a basic state, i.e. a state where theuser provided values 
        // (namely occupants and travel dates) are left untouched,
        // but the rest is set to the default. THis is to allow direct searches (from the header or links)
        // where a basic value is used
        let base = state.defaultQuery;
        base.numberOfKids = state.query.numberOfKids;
        base.numberOfAdults = state.query.numberOfAdults;
        base.selectedDates = state.query.selectedDates;

        // Select all regions
        let regions = state.regions;
        for (let i = 0; i < regions.length; i++) {
            Vue.set(state.regions[i], 'value', true);
        }

        // Select all house types
        let houseTypes = state.houseTypes;
        for (let i = 0; i < houseTypes.length; i++) {
            Vue.set(state.houseTypes[i], 'value', true);
        }

        // Deselect all props
        let properties = state.properties;
        for (let i = 0; i < properties.length; i++) {
            Vue.set(state.properties[i], 'value', false);
        }

        Object.assign(state.query, base);
    },



    setLocale(state, locale) {
        state.locale = locale;
    },
    setOffer(state, offer) {
        state.offer = offer
    },
    // TODO: Remove this
    setLowestPrice(state, lowestPrice) {
        state.lowestPrice = lowestPrice
    },
    
    // Required data
    setFetchingRegions(state, fetching) {
        state.fetchingRegions = fetching;
    },
    setRegions(state, regions) {
        // Before setting it, check if we have a value attribute
        for (let i = 0; i < regions.length; i++) {
            if (regions[i].value === undefined) {
                Vue.set(regions[i], 'value', false);
            }
        }

        state.regions = regions;
    },
    setHouseTypes(state, houseTypes) {
        // Before setting it, check if we have a value attribute
        for (let i = 0; i < houseTypes.length; i++) {
            if (houseTypes[i].value === undefined) {
                Vue.set(houseTypes[i], 'value', true);
            }
        }

        state.houseTypes = houseTypes;
    },
    setProperties(state, properties) {
        state.properties = properties;
    },
    setBookingRequestConfirmation(state, bookingRequestConfirmation) {
        state.bookingRequestConfirmation = bookingRequestConfirmation;
    },
    setCurrentListing(state, listing) {
        state.currentListing = listing;
    },


    // Auth
    auth_request(state) {
    state.status = 'loading';
    },
    auth_success(state, token) {
    state.status = 'success';
    state.token = token;
    },
    auth_error(state) {
    state.status = 'error';
    state.token = '';
    },
    logout(state) {
    state.status = '';
    state.token = '';
    },
    setRole(state, role) {
    state.role = role;
    },
}
